<template>
  <section class="db-card">
    <div class="db-card-head">
      <h2 class="db-card-title">
        {{ title }}<span class="db-card-cut" v-if="cut"> — {{ cut }}</span>
      </h2>
      <span class="db-card-note" v-if="note">{{ note }}</span>
    </div>
    <slot/>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    cut: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
  },
};
</script>
